import { createFileRoute, redirect } from "@tanstack/react-router";
import { z } from "zod";

const verifyEmailSearchSchema = z.object({
  email: z.string().optional(),
});

/** Legacy URL — verification is handled inline on sign-in / sign-up. */
export const Route = createFileRoute("/verify-email")({
  validateSearch: (search) => verifyEmailSearchSchema.parse(search),
  beforeLoad: ({ search }) => {
    throw redirect({
      to: "/sign-in",
      search: search.email ? { email: search.email } : undefined,
      replace: true,
    });
  },
});
